import { useEffect } from 'react';
import { useDragDropManager } from 'react-dnd';
import { useStoreMap } from 'effector-react';
import Button from '@components/Button';
import Modal from '@components/Modal';
import Tip from '@components/Tip';
import Title from '@components/Title';
import IconPlus from '@components/icons/IconPlus';
import { $selectedPath } from '@stores/dataStores';
import useToggle from '@hooks/useToggle';
import { MCategoryList } from './MCategoryList';
import {
  $scenesManagement,
  $scenesManagementApi,
  setGlobalDragging,
} from './stores';
import { MSceneList } from './MSceneList';
import addScenes from '../actions/addScenes';
import { DragLayer } from './DragLayer';
import SearchBar from './SearchBar';
import { ResultList } from './ResultList';

interface Props {
  onRequestClose: () => void;
}

export function ScenesManagementModal({ onRequestClose }: Props) {
  const query = useStoreMap({
    store: $scenesManagement,
    keys: [],
    fn: (state) => state.query,
  });

  const loading = useToggle(true);
  useEffect(() => {
    const { categoryPath } = $selectedPath.getState();
    $scenesManagementApi.update((draft) => {
      draft.categoryPath = categoryPath;
    });
    loading.off();
    return () => {
      $scenesManagementApi.reset();
    };
  }, []);

  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();
  useEffect(() => {
    return monitor.subscribeToStateChange(() => {
      if (monitor.isDragging()) {
        setGlobalDragging(monitor.getItemType());
      } else {
        setGlobalDragging(null);
      }
    });
  }, [monitor]);
  return (
    <Modal
      isOpen
      style={{ width: 1000, height: 'calc(100% - 60px)' }}
      backdropZIndex={10500}
      onRequestClose={onRequestClose}
      header={
        <div className="flex w-full items-center">
          <Title>场景管理</Title>
          <SearchBar />
          <Tip className="ml-auto text-orange">
            拖拽分组/场景可以调整其先后顺序
          </Tip>
          <Button
            className="ml-10"
            onClick={() => {
              const { categoryPath } = $scenesManagement.getState();
              const categoryId = categoryPath[categoryPath.length - 1];
              if (!categoryId) return;
              addScenes(categoryId);
            }}
          >
            <IconPlus active className="mr-5" />
            添加场景
          </Button>
        </div>
      }
    >
      {!loading.isOn && (
        <div className="absolute inset-0 grid grid-cols-[200px_1fr]">
          <DragLayer />
          <MCategoryList />
          {query ? <ResultList /> : <MSceneList />}
        </div>
      )}
    </Modal>
  );
}

export default ScenesManagementModal;
